/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // --- Free shipping threshold currency-conversion fix ---
  function correctFreeShippingLimit() {
    var cartItemsEls = document.querySelectorAll('cart-items');
    cartItemsEls.forEach(function (cartItems) {
      if (!cartItems || !cartItems.freeShipping || !cartItems.freeShipping.length) return;
      var attr = cartItems.freeShipping[0].getAttribute('data-free-shipping-limit');
      if (attr === null) return;
      var correctLimit = 100 * Number(attr);
      if (cartItems.freeShippingLimit !== correctLimit) {
        cartItems.freeShippingLimit = correctLimit;
        if (typeof cartItems.updateProgress === 'function') {
          cartItems.updateProgress();
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', correctFreeShippingLimit);
  document.addEventListener('theme:cart:change', correctFreeShippingLimit);
  document.addEventListener('theme:product:added', correctFreeShippingLimit);
  document.addEventListener('theme:announcement:init', correctFreeShippingLimit);
  correctFreeShippingLimit();

  // --- Cart DRAWER "X items" count fix (scoped, does not touch header badge) ---
  function correctCartCountText() {
    document.querySelectorAll('cart-count.cart__items-count').forEach(function (el) {
      var count = el.getAttribute('data-cart-count');
      if (count === null) return;
      var desired = count + ' items';
      if (el.textContent !== desired) {
        el.textContent = desired;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', correctCartCountText);
  document.addEventListener('theme:cart:change', correctCartCountText);
  document.addEventListener('theme:product:added', correctCartCountText);
  correctCartCountText();

  // --- Free shipping progress bar color ---
  // The theme's own CSS applies a gradient to the filled portion of the bar
  // (previously blue-to-black). This overrides that gradient's start color
  // to brand purple (#3820ba), keeping the same fade-to-black shape.
  // Track (unfilled background): brand warm off-white (#fcfbf9).
  var style = document.createElement('style');
  style.textContent =
    '[data-progress-bar] { accent-color: #3820ba; background-color: #fcfbf9; border-radius: 4px; }' +
    '[data-progress-bar]::-webkit-progress-bar { background-color: #fcfbf9; border-radius: 4px; }' +
    '[data-progress-bar]::-webkit-progress-value { background-color: #3820ba !important; background-image: linear-gradient(to right, #3820ba, #000000) !important; border-radius: 4px; }' +
    '[data-progress-bar]::-moz-progress-bar { background-color: #3820ba !important; background-image: linear-gradient(to right, #3820ba, #000000) !important; }';
  document.head.appendChild(style);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
